import { useState } from "react";
import PasswordRequestForm from "../../components/PasswordRequestForm/PasswordRequestForm";
import REGEX from "../../utils/regex";
import Swal from "sweetalert2";
import { api } from "../../services/api";
import { useNavigate } from "react-router-dom";

function PasswordRequestFormContainer(){
    const [dataRequestNewPassword, setDataRequestNewPassword] = useState([
		{
			id: "userEmail",
			type: "email",
			label: "Email",
			value: "",
			error: "",
			regEx: REGEX.emailFormatValidator,
			regMessage: "El formato de email es inválido (Ej: usuario@correo.com ).",
		},
		{
			id: "userEmailConfirmation",
			type: "email",
			label: "Repetir Email",
			value: "",
			error: "",
			regEx: REGEX.emailFormatValidator,
			regMessage: "El formato de email es inválido (Ej: usuario@correo.com ).",
		}])

    const navigate = useNavigate()

    const createDataApi = (data) => {
        let formattedData = [];
        formattedData = data.map((el) => {
            return [...formattedData, el.id, el.value];
        });
            return Object.fromEntries(formattedData);
        }

    function cleanForm(){
        const newDataRequestNewPassword = [...dataRequestNewPassword];
		newDataRequestNewPassword.forEach((data) => {
			data.value = ''
		});
		setDataRequestNewPassword(newDataRequestNewPassword);
    }  

    function sendEmailApi(){
        const dataAPI = createDataApi(dataRequestNewPassword);
        if(dataAPI.userEmail === dataAPI.userEmailConfirmation ){
            api.account
                .resetPassword(dataAPI.userEmail)
                .then((data) => {
                    if (data.status !== 200) {
						Swal.fire({
							customClass: {
								confirmButton: "swalBtnOk",
							},
							position: "center",
							icon: "error",
							title: "Hubo un error",
                            text: "El email no se encuentra en nuestra base de datos",
							showConfirmButton: true,
							focusConfirm: false,
							iconColor: "#FF8A65",
							color: "#292929",
                            background: "#FAFAFA",
                            confirmButtonColor: "rgb(230, 11, 19)",
						});
						return;
					}
					if (data.status === 200) {
                        Swal.fire({
							customClass: {
								confirmButton: "swalBtnOk",
							},
							position: "center",
							icon: "success",
							title: "Contraseña enviada",
                            text: "La nueva contraseña ha sido enviada a su email",
							showConfirmButton: true,
							focusConfirm: false,
							iconColor: "#36A160",
							color: "#292929",
                            background: "#FAFAFA",
                            confirmButtonColor: "rgb(230, 11, 19)",
						}).then(() => {navigate("/")})
                    cleanForm()
					}
                })
        }else{
            Swal.fire({
                customClass: {
                    confirmButton: "swalBtnOk",
                    title: "swalTitle",
                },
                position: "center",
                icon: "error",
                title: "Error en email",
                text: "Los emails no coinciden",
                width: "350px",
                showConfirmButton: true,
                focusConfirm: false,
                iconColor: "#FF8A65",
                color: "#292929",
                background: "#FAFAFA",
                confirmButtonColor: "rgb(230, 11, 19)",
            });
        }
    }

    function handleChange(e){
        const newDataRequestNewPassword = [...dataRequestNewPassword];
		newDataRequestNewPassword.forEach((dato) => {
			if (e.target.name === dato.id) dato.value = e.target.value;
		});
		setDataRequestNewPassword(newDataRequestNewPassword);
    }

    function emailValidation(){
        let errorMessage = "";
		const newDataRequestNewPassword = [...dataRequestNewPassword];
		newDataRequestNewPassword.forEach((field) => {
			field.error = !field.value.toString().match(field.regEx)
				? field.regMessage
				: "";
			errorMessage = errorMessage + field.error;
		});
		setDataRequestNewPassword(newDataRequestNewPassword);

		return errorMessage;
    }

    function handleSubmit(e){
        e.preventDefault();
        let validatingError = "";
		validatingError = emailValidation();
		if (validatingError !== "") {
			return;
		}
		sendEmailApi()
    }



    function disablePaste(e){
        e.preventDefault()
        return false;
    }

    return(
        <PasswordRequestForm
            handleChange={handleChange}
            dataRequestNewPassword={dataRequestNewPassword}
            handleSubmit={handleSubmit}
            disablePaste={disablePaste}
        />
    )
}

export default PasswordRequestFormContainer;